import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, useSearchParams } from "react-router-dom"; 
import { getFirestore, doc, setDoc, getDoc,query,where, getDocs , updateDoc, collection } from "firebase/firestore";
import { db } from "../firebase"; 
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
 
import { Helmet } from "react-helmet";  
import Lodinging from "../components/loading";  
import Cookies from 'js-cookie';
import { useToast } from '../components/ToastContext';    
import Header from '../master_root/header';
//page links  
export default function Privacypolicy() {
  return (
           <div >
       <Header /> 
     <div className='app_header_height'></div>
    <div className="container_roots">
  
    <Helmet>
        <title>Privacy Policy - EditorTask</title>
        <meta name="description" content="Read our privacy policy to understand how EditorTask collects, uses, and protects your personal information." />
        <meta name="keywords" content="privacy policy, data protection, user data, editor task policy, GDPR compliance" />
        <meta name="author" content="editortask.com" />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="Privacy Policy - EditorTask" />
        <meta property="og:description" content="EditorTask respects your privacy and is committed to protecting your data. Learn more in our privacy policy." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.editortask.com/privacy-policy" />
        <meta property="og:image" content="https://www.editortask.com/editortask_logo.png" />
      </Helmet>

      <div className="container_size">
        <h2 className="contact-title">Privacy Policy</h2>

        <div className="policy-section">
          <h2>1. Introduction</h2>
          <p>EditorTask is committed to protecting your personal information. This Privacy Policy explains how we collect, use, and safeguard your data when you visit our website or use our services.</p>
        </div>

        <div className="policy-section">
          <h2>2. Information We Collect</h2>
          <ul>
            <li>Personal Information (Name, Email, Phone Number)</li>
            <li>Location Data (Country, City, IP address)</li>
            <li>Profile Information (Skills, Portfolio, Resume)</li>
            <li>Usage Data (Pages visited, browser type, device info)</li>
          </ul>
        </div>

        <div className="policy-section">
          <h2>3. How We Use Your Information</h2>
          <ul>
            <li>To create and manage user accounts</li>
            <li>To match freelancers with job providers</li>
            <li>To improve our platform and personalize user experience</li>
            <li>To send notifications, alerts, or updates</li>
          </ul>
        </div>

        <div className="policy-section">
          <h2>4. Cookies and Tracking</h2>
          <p>We use cookies to store preferences, analyze traffic, and improve site experience. You can control cookie settings in your browser.</p>
        </div>

        <div className="policy-section">
          <h2>5. Sharing of Information</h2>
          <p>We do not sell or share your personal information with third parties except when required by law or for service-related purposes (like payment gateways).</p>
        </div>

        <div className="policy-section">
          <h2>6. Data Security</h2>
          <p>We implement security measures to protect your information, including encryption and secure server infrastructure.</p>
        </div>

        <div className="policy-section">
          <h2>7. Your Rights</h2>
          <p>You can request access to your data, correct or delete it, and opt out of communications at any time.</p>
        </div>

        <div className="policy-section">
          <h2>8. Changes to this Policy</h2>
          <p>We may update this policy occasionally. All changes will be posted here with the latest revision date.</p>
        </div>

        <div className="policy-section">
          <h2>9. Contact Us</h2>
          <p>If you have any questions about our Privacy Policy, reach out to us at <b>support@editortask.com</b>.</p>
        </div>
      </div>
    </div>
</div>
    );
}
